/** Bornes d'une étiquette, les mêmes que l'API (#29). */
export const TAG_MAX_LENGTH = 40
export const TAGS_PER_PATH = 10

/**
 * Ajoute l'étiquette saisie à la liste, comme l'API l'enregistrera : espaces
 * resserrés, vide ignoré, doublon écarté sans égard à la casse, et rien au-delà
 * des bornes — la saisie trop longue est coupée, une onzième n'entre pas.
 */
export function addTag(tags: readonly string[], raw: string): string[] {
  // Par caractères et non par unités UTF-16 : un emoji coupé en deux casserait l'écriture.
  const name = Array.from(raw.trim().replace(/\s+/g, ' ')).slice(0, TAG_MAX_LENGTH).join('')
  if (!name || tags.length >= TAGS_PER_PATH) return [...tags]
  const key = name.toLocaleLowerCase('fr')
  return tags.some(tag => tag.toLocaleLowerCase('fr') === key) ? [...tags] : [...tags, name]
}
